var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetaliate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 75.972656 195.84375 C 75.972656 195.84375 42.015625 145.695313 42.148438 143.03125 C 42.445313 137.09375 90.214844 86.359375 99.117188 81.90625 C 108.015625 77.457031 129.378906 77.457031 143.621094 73.898438 C 157.863281 70.335938 168.542969 65.886719 172.996094 72.117188 C 177.445313 78.347656 169.433594 108.613281 158.753906 113.953125 C 140.582031 123.039063 125.820313 121.964844 125.820313 121.964844 L 121.367188 127.304688 C 121.367188 127.304688 148.679688 155.183594 143.621094 176.261719 C 138.28125 198.515625 124.039063 221.65625 90.214844 230.558594 C 79.023438 233.503906 75.972656 195.84375 75.972656 195.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 152.132813 129.59375 C 150.292969 129.15625 148.722656 130.992188 149.460938 132.734375 C 154.40625 144.40625 165.378906 178.363281 143.621094 211.863281 C 124.929688 240.648438 94.664063 241.238281 94.664063 241.238281 L 102.082031 276.25 L 163.5 276.25 L 168.902344 245.066406 C 169.300781 242.777344 172.421875 242.363281 173.375 244.480469 C 175.949219 250.195313 179.195313 260.355469 179.980469 276.25 L 221.5 276.25 C 221.5 276.25 214.257813 234.121094 216.90625 216.316406 C 218.984375 202.371094 245.390625 173.886719 245.390625 173.886719 L 235.304688 149.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 65.90625 94.277344 L 59.949219 53.425781 C 59.949219 53.425781 84.140625 29.957031 94.664063 26.71875 C 102.378906 24.347656 111.574219 31.171875 111.574219 31.171875 L 113.355469 66.183594 C 113.355469 66.183594 98.222656 67.960938 93.179688 70.632813 C 85.367188 74.769531 65.90625 94.277344 65.90625 94.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 129.378906 63.808594 L 129.972656 33.546875 C 129.972656 33.546875 150.148438 24.042969 158.160156 23.753906 C 166.171875 23.460938 178.039063 37.996094 178.039063 37.996094 C 178.039063 37.996094 175.632813 55.796875 171.511719 56.6875 C 167.390625 57.578125 129.378906 63.808594 129.378906 63.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 192.578125 47.488281 C 192.578125 47.488281 175.660156 97.988281 173.886719 118.402344 C 173.292969 125.226563 202.367188 130.863281 204.148438 126.414063 C 205.929688 121.964844 224.027344 63.214844 223.140625 56.09375 C 222.246094 48.972656 201.183594 43.335938 192.578125 47.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 231.148438 77.160156 C 231.148438 77.160156 212.160156 129.679688 214.832031 132.644531 C 220.191406 138.605469 239.457031 141.84375 244.796875 132.050781 C 250.136719 122.261719 257.855469 100.007813 257.855469 94.664063 C 257.855469 89.324219 253.699219 79.535156 250.136719 77.753906 C 246.15625 75.765625 236.488281 74.785156 231.148438 77.160156 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetaliate);
export default __webpack_public_path__ + "static/media/Retaliate.cbf031d134591ab1da99dcc0abc81f0e.svg";
export { ForwardRef as ReactComponent };